import { LOCAL_STORAGE_KEY } from "../Config";

export const getOptions = (data = [], key, value, item = "Description") => {
  const arr = [...data] ?? [];
  const result = arr.filter((word) => word[key] === value);
  console.log("result", result, { [key]: "" });

  return result.length ? result.pop() : { [item]: "" };
};

export const IsLogin = () => {
  const userdata = localStorage.getItem(LOCAL_STORAGE_KEY.user_token);

  if (userdata) {
    return true;
  }

  return false;
};

export const LogOut = () => {
  localStorage.clear();
  window.location.reload(false);
};

// export const IsAdmin = () => {
//   const userData = JSON.parse(
//     localStorage.getItem(LOCAL_STORAGE_KEY.user_token)
//   );
//   if (userData) {
//     return userData.user_roles.includes("ADM");
//   }
// };

export const IsShowOutstanding = () => {
  const userData = JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_KEY.user_token)
  );
  if (userData) {
    return userData.show_shipment === "Y" && userData.show_outstanding === "Y";
  }
};

export const IsShowOrder = () => {
  const userData = JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_KEY.user_token)
  );
  if (userData) {
    return userData.show_orderMangement === "Y" ? true : false;
  }
};

export const IsShowReports = () => {
  const userData = JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_KEY.user_token)
  );
  if (userData) {
    return Boolean(userData.show_outstanding);
  }
};

export const IsShowShipment = () => {
  const userData = JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_KEY.user_token)
  );
  if (userData) {
    return userData.show_shipment === "Y";
  }
};
